import { createSelector } from '@reduxjs/toolkit';
import { selectRailwayAndHighwayPuids } from './selectRailwayAndHighwayPuids';
import { selectAdfoxPuids } from './selectAdfoxPuids';

export const selectBannerPuids = createSelector(
  [selectRailwayAndHighwayPuids, selectAdfoxPuids],
  (railwayAndHighwayPuids, adfoxPuids) => {
    const puids: Record<string, string | null | undefined> = {
      ...railwayAndHighwayPuids,
      ...adfoxPuids,
    };

    const commercialReg = /commercial$/gm;

    /**
     * @description Сейчас существует баг, что для гаражей приходит puid2 = offer_commercial, а не offer_flat
     * Это происходит из-за того, что когда гаражи переезжали из коммерческой в жилую,
     * не поменяли отправляемый в jsonQuery _type
     */
    if (puids.puid2 && puids.puid2.match(commercialReg)) {
      puids.puid2 = puids.puid2.replace(commercialReg, 'flat');
    }

    return puids;
  },
);
